<template>
  <div class="_content">
      <div class="banner">
          <div class="ban-con">
              <img :src="configData.bannerPic" />
          </div>
          <p><van-icon name="shop" color="#1677FF" size="30px" style="float: left;margin-right: 10px" />{{ configData.shopName }}</p>
      </div>
      <div class="shop-list">
          <van-tree-select height="auto" @click-nav="navClick" :items="items" :active-id.sync="activeId" :main-active-index.sync="activeIndex">
            <template #content>
                <div class="list">
                    <h4 style="font-weight: bold;margin-top: 10px">{{serName}}</h4>
                    <ul style="padding-bottom: 20px">
                        <li v-for="(item, index) in goodsListd" :key="index">
                            <div class="left">
                                <img :src="item.goodsPic"/>
                            </div>
                            <div class="right">
                                <h3>{{ item.goodsName}}</h3>
                                <div class="sn">
                                    <span>￥ {{item.goodsPrice}}</span>
                                    <van-stepper v-model="item.buySum" integer min="0" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </van-tree-select>
      </div>
      <div :class="czlass">
          <div class="cz-top" @click="animh">
              <p><van-icon :name="arrow" /></p>
              <p>查看操作流程</p>
          </div>
          <div class="cz-con">
              <p>1、请引导客户打开并登录杉德宝APP，出示付款码；</p>
              <p>2、用户需提前绑定杉德预付卡；</p>
              <p>3、如用户没有设置免密支付，则收到订单后需输入支付密码。</p>
              <p>4、如有问题请联系小鲲车服：<i v-call style="color: #016EEF">400-176-8848</i></p>
          </div>
      </div>
      <div class="botSub">
          <h5>合计：<span>￥ {{ totalPrice }}</span></h5>
          <div class="btn"><van-button round style="width: 5rem;margin: 0px;padding: 0px;" size="normal" type="info" @click="submit" :disabled="disable">去提交</van-button></div>
      </div>
      <van-popup
        v-model="showMob"
        closeable
        close-icon="close"
        close-icon-position="top-right"
        :style="{ width: '80%' }"
        class="pop"
        >
        <div class="sub">
            <p>请填写顾客手机号</p>
            <input class="inputs" type="number" placeholder="请输入手机号" v-model="phone"/>
            <input class="button" type="button" value="确认提交" @click="submit" :disabled="inputDis">
        </div>
        </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import config from '@/configs/config'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
export default {
  data() {
    return {
        active: 0,
        activeId: 0,
        activeIndex: 0,
        items: [],
        value: 0,
        configData: {},
        // disable: true,
        czlass: 'cz',
        arrow: 'arrow-up',
        goodsListd: [],
        goodsLists: [],
        serName: '',
        amount: 0,
        amounts: 0,
        showMob: false,
        phone: '',
        channelcode: '',
        shopid: '',
        inputDis: false
        }
    },
    mounted () {
        // let vConsole = new VConsole()
        // alert(location.pathname)
    },
//       beforeRouteEnter(to, from, next) {
//     if (to.path !== location.pathname) {
//          location.assign(to.fullPath) 
//          console.log(to.path, location.pathname)
//     } else {
//         next()
//     }
// },
  methods: {
      init() {
          this.channelcode = tuhu.getParam('channelcode')
          this.shopid = tuhu.getParam('shopid')
      },
    //   首页商品配置
      indexConfig() {
           let channelcode = tuhu.getParam('channelcode')
           let shopid = tuhu.getParam('shopid')
           tuhu.fetch(`${config.apis.INDEX_CONFIG}/${channelcode}/${shopid}`)
           .then((data) => {
                    if (data && data.code === '200') {
                        this.configData = data.data
                        if (data.data.pageTitle && data.data.pageTitle !== null) {
                          document.title = data.data.pageTitle
                        } else {
                          document.title = '\u200E' // 根据后台返回字段修改页面title
                        }
                        console.log((document.title), 'sdsds')
                    } else {
                    tuhu.toast(data.message || '网络错误')
                    }
                }).catch(
                    //   () => {
                    // tuhu.toast('查询商品时出错')
                    error => console.error('Error:', error)
                //   }
                )
                },
    //   商品列表
      goodsList() {
          let channelcode = tuhu.getParam('channelcode')
           let shopid = tuhu.getParam('shopid')
          tuhu.fetch(`${config.apis.GOOD_LISTS}/${channelcode}/${shopid}`)
           .then((data) => {
                    if (data && data.code === '200') {
                        data.data.map((item, index) => {
                            this.items.push({
                                text: item.goodsClassification,
                                activeId: index
                            })
                            this.goodsLists.push({
                                list: item.goodsDtos,
                                id: index,
                                name: item.goodsClassification
                            })
                            this.goodsListd = this.goodsLists[0].list
                            this.serName = this.goodsLists[0].name
                        })
                    } else {
                    tuhu.toast(data.message || '网络错误')
                    }
                }).catch(
                    //   () => {
                    // tuhu.toast('查询商品时出错')
                    error => console.error('Error:', error)
                //   }
                )
      },
    //   左侧点击
      navClick(index) {
            let activeId = this.items[index].activeId
            this.goodsLists.map((item, index) => {
                if (item.id === activeId) {
                    this.goodsListd = item.list
                    this.serName = item.name
                }
            })
            console.log(this.goodsListd)
      },
    //   操作手册控制
      animh() {
          if (this.czlass === 'cz') {
              this.czlass = 'cz1'
              this.arrow = 'arrow-down'
          } else {
              this.czlass = 'cz'
              this.arrow = 'arrow-up'
          }
      },
      dialog() {
          Dialog.alert({
            title: '提示',
            allowHtml: true,
            // 修复：原代码 v-call 在字符串中不生效（Vue指令不会编译动态HTML），点击无法拨号
            // 改用原生 onclick 实现拨号功能
            message: '您暂未开通此服务，\n如需开通请联系：' + `<i onclick="window.location.href='tel:400-176-8848'" style="color: #016EEF">400-176-8848</i>`
            }).then(() => {
            // on close
            })
      },
    //   提交显示输入手机号
      showMobs() {
          this.showMob = true
          this.inputDis = false
      },
    //   提交订单
      submit() {
           this.inputDis = true
          let newBackUrl = window.location.href
          tuhu.sessionStorage.setItem('newBackUrl', JSON.stringify(newBackUrl))
        //   let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
        //   if (!reg.test(this.phone)) {
        //       tuhu.toast('请输入正确的手机号', 500)
        //       this.inputDis = false
        //   } else {
        //     this.inputDis = true  // 重复点击限制
          let params = {
              channelCode: this.channelcode,
              goodsDto: [],
              goodsPriceTotal: this.totalPrice,
              mobile: '13000000000',
              orderNote: '',
              shopName: this.configData.shopName,
              vehicleName: '',
              verifyCode: '',
              submitShopId: this.shopid,
              projectDetailId: this.configData.projectDetailId,
              pageType: '1'  // 页面类型
          }
          JSON.parse(JSON.stringify(this.goodsLists)).forEach((good) => { // 深拷贝一下 不改变计算价格值
            good.list.forEach((item) => {
                if (item.buySum > 0) {
                    // item.goodsPrice = item.buySum * item.goodsPrice
                    params.goodsDto.push(item)
                    
                }
            })
        })
        // 传参里商品价格为总计
        params.goodsDto.forEach((item) => {
             if (item.buySum > 0) {
                    item.goodsPrice = (item.buySum * item.goodsPrice).toFixed(2)
                }
        })
        tuhu.fetch(`${config.apis.GOOD_SUBMIT}`, {
            method: 'post',
            body: JSON.stringify(params)
        })
           .then((data) => {
                    if (data.code === '200') {
                        // this.showMob = false
                    tuhu.sessionStorage.setItem('shopBill', JSON.stringify(data.data))
                    let queryList = {
                                goodsOrderId: data.data.goodsOrderId,
                                goodsPriceTotal: this.totalPrice,
                                channelCode: this.channelcode,
                                shopName: this.configData.shopName
                    }
                    tuhu.sessionStorage.setItem('queryList', JSON.stringify(queryList))
                    //    tuhu.navigateTo({
                    //         url: '/pages/cashiers/index'
                    //     })
                    // IOS下微信扫一扫需要刷新地址
                    window.location.href = 'http://m.hzqmtech.com/shop/pages/cashiers/index'
                    // window.location.href = 'http://www.xiaokunkeji.com/shop/pages/cashiers/index'
                    } else {
                    tuhu.toast(data.message || '网络错误')
                    this.inputDis = false
                    }
                }).catch(
                    error => console.error('Error:', error)
                )

        console.log(params)
          }
    //   }
  },
  computed: {
    //   价格计算
 totalPrice() {
        let total = 0
        this.goodsLists.forEach((good) => {
            good.list.forEach((item) => {
                total += item.goodsPrice * item.buySum
            })
        })
        return total.toFixed(2)
      },
      disable() {
          if (this.totalPrice > 0) {
              return false
          } else {
              return true
          }
      }
  },
  created() {
      let md = navigator.userAgent
    // 品牌
    // this.brand = md.mobile()
      console.log(md, '2323')
      this.indexConfig()
      this.goodsList()
      this.init()
  }
  
}
</script>
<style lang="less" scoped>
._content{
    .banner{
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 10px #9e9e9e;
        position: relative;
        z-index: 30;
        .ban-con{
            width: 100%;
            height: 160px;
            background-color: #eee;
        }
        p{
            width: 100%;
            background-color: #fff;
            padding: 10px;
            font-size: 0.8rem;
            overflow: hidden;
            line-height: 30px;
            font-weight: bold;
            color: #333;
        }
    }
    .shop-list{
        // margin-top: 10px;
        position: relative;
        z-index: 10;
    }
    .list{
       width: 96%;
       margin-left: 2%;
    //    background-color: #999;
       height: calc(100vh - 210px);
       overflow-y: auto;
       padding-bottom: 110px;
       ul li{
           width: 100%;
           margin-top: 10px;
           overflow: hidden;
        //    display: flex;
           .left{
               float: left;
               width: 70px;
               height: 70px;
               background-color: #eee;
               img{
                   width: 70px;
                   height: 70px;
               }
           }
           .right{
               width: calc(100% - 80px);
               float: left;
               margin-left: 10px;
               height: 70px;
               position: relative;
                h3{
                    font-size: 14px;
                    // margin-bottom: 20px;
                    margin-left: 5px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                }
                div.sn{
                    position: relative;
                    top: 41px;
                    left: 0px;
                    overflow: hidden;
                    span{
                        font-size: 0.8rem;
                        color: red;
                        margin-right: 10px;
                        float: left;
                    }
                }
           }
       }
    }
    .botSub{
        width: 100%;
        height: 70px;
        background-color: #fff;
        position: fixed;
        left: 0px;
        bottom: 0px;
        z-index: 2000;
        overflow: hidden;
        padding-top: 10px;
        h5{
            float: left;
            margin-left: 10%;
            line-height: 50px;
            font-size: 0.7rem;
            span{
                font-size: 1rem;
                color: #006EEF;
            }
        }
        div.btn{
            float: right;
            margin-right: 10%;
        }
    }
    .cz{
        width: 100%;
        background-color: #FFFBE3;
        position: fixed;
        left: 0px;
        bottom: 70px;
        z-index: 2000;
        height: 44px;
        .cz-top{
            text-align: center;
            height: 40px;
            margin: 5px 0px;
            p{
                color: #FF3B30;
            }
        }
        .cz-con{
            width: 90%;
            margin-left: 8%;
            margin-bottom: 10px;
            p{
                line-height: 20px;
            }
        }
    }
     .cz1{
        width: 100%;
        background-color: #FFFBE3;
        position: fixed;
        left: 0px;
        bottom: 70px;
        z-index: 2000;
            height: 22vh;
        }
        .cz-top{
            text-align: center;
            height: 40px;
            margin: 5px 0px;
            p{
                color: #FF3B30;
            }
        }
        .cz-con{
            width: 90%;
            margin-left: 8%;
            margin-bottom: 10px;
            p{
                line-height: 20px;
            }
        }
        .pop{
            border-radius: 10px;
        }
        .sub{
            width: 100%;
            padding: 20px;
            text-align: center;
            p{
                font-size: 0.8rem;
                color: #333;
                font-weight: 500;
            }
            .inputs{
                width: 100%;
                margin-top: 20px;
                border: 1px solid #eee;
                height: 50px;
                // line-height: 50px;
                font-size: 16px;
                border-radius: 5px;
                padding-left: 10px;
                -webkit-user-select:auto;
            }
            .button{
                width: 100%;
                margin-top: 20px;
                color: #fff;
                background-color: #1989fa;
                height: 40px;
                border-radius: 20px;
            }
        }
       
}
</style>


// WEBPACK FOOTER //
// src/pages/shopBill/index.vue